// FIN-HUBS: Pagamentos — CP + Cartões + Reembolsos Campo + Combustíveis + Empréstimos + Diferimentos.
// O badge de reembolsos aguardando revisão fica NA ABA "Reembolsos Campo"
// (pedido do Lucas 2026-07-27 — antes ficava no item "Pagamentos" da sidebar).
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Badge } from 'antd';
import HubAbas, { HubTab } from '../../components/HubAbas';
import FinanceiroContasPagar from '../FinanceiroContasPagar';
import FinanceiroCartoes from '../FinanceiroCartoes';
import FinanceiroReembolsosCampo from '../FinanceiroReembolsosCampo';
import FinanceiroCombustiveis from '../FinanceiroCombustiveis';
import Emprestimos from '../Emprestimos';
import Diferimentos from '../Diferimentos';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';

export default function FinanceiroPagamentosHub() {
  const [reembolsosPendentes, setReembolsosPendentes] = useState(0);
  // Notas de combustível (cartão Ticket Log) esperando conferência.
  const [combustivelPendente, setCombustivelPendente] = useState(0);

  useEffect(() => {
    async function contar() {
      try {
        const token = await getToken();
        const r = await axios.get(`${API_URL}/mobile/reembolsos/contagem-pendente`,
          { headers: { Authorization: token } });
        const d = r.data?.body ? JSON.parse(r.data.body) : r.data;
        setReembolsosPendentes(typeof d?.aguardando_revisao === 'number' ? d.aguardando_revisao : 0);
      } catch { /* badge é opcional */ }
      try {
        const token = await getToken();
        const r = await axios.get(`${API_URL}/mobile/combustivel/contagem-pendente`,
          { headers: { Authorization: token } });
        const d = r.data?.body ? JSON.parse(r.data.body) : r.data;
        setCombustivelPendente(typeof d?.aguardando_revisao === 'number' ? d.aguardando_revisao : 0);
      } catch { /* badge é opcional */ }
    }
    contar();
    const id = setInterval(contar, 60_000);
    return () => clearInterval(id);
  }, []);

  const tabs: HubTab[] = [
    { key: 'contas-pagar',     label: 'Contas a Pagar',       perm: 'financeiro.contas_pagar.ver', render: () => <FinanceiroContasPagar /> },
    // cartoes e reembolsos reusam a perm de contas_pagar (mesmo escopo — F5).
    { key: 'cartoes',          label: '💳 Cartões de crédito', perm: 'financeiro.contas_pagar.ver', render: () => <FinanceiroCartoes /> },
    { key: 'reembolsos-campo',
      label: (
        <Badge count={reembolsosPendentes} size="small" offset={[8, -2]}>
          <span>📱 Reembolsos Campo</span>
        </Badge>
      ),
      perm: 'financeiro.contas_pagar.ver', render: () => <FinanceiroReembolsosCampo /> },
    // Ao lado do reembolso de propósito: é o mesmo gesto no app de campo (foto
    // do comprovante + centro de custo), com o mesmo revisor.
    { key: 'combustiveis',
      label: (
        <Badge count={combustivelPendente} size="small" offset={[8, -2]}>
          <span>⛽ Combustíveis</span>
        </Badge>
      ),
      perm: 'financeiro.contas_pagar.ver', render: () => <FinanceiroCombustiveis /> },
    { key: 'emprestimos',      label: 'Empréstimos',          perm: 'financeiro.emprestimos.ver',  render: () => <Emprestimos /> },
    { key: 'diferimentos',     label: 'Diferimentos',         perm: 'financeiro.diferimentos.ver', render: () => <Diferimentos /> },
  ];

  return <HubAbas tabs={tabs} />;
}
